var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-navbar",
    { attrs: { toggleable: "md", type: "light" } },
    [
      _c("b-navbar-toggle", { attrs: { target: "nav_collapse" } }),
      _vm._v(" "),
      _c("b-navbar-brand", { attrs: { to: { name: "BrandListClient" } } }, [
        _c("img", {
          attrs: { src: require("../assets/Derco.gif"), width: "60", alt: "" }
        }),
        _vm._v(" "),
        _c("span", [_vm._v("Administración de Pedidos")])
      ]),
      _vm._v(" "),
      _c(
        "b-collapse",
        { attrs: { "is-nav": "", id: "nav_collapse" } },
        [
          _c(
            "b-navbar-nav",
            { staticClass: "ml-auto" },
            [
              _c(
                "b-nav-item",
                { attrs: { to: { name: "LandingMotorwowLeads" } } },
                [_vm._v("Motorwow")]
              ),
              _vm._v(" "),
              _c("b-nav-item", { attrs: { to: { name: "Auditoria" } } }, [
                _vm._v("Auditoría")
              ]),
              _vm._v(" "),
              _c(
                "b-nav-item-dropdown",
                { staticClass: "ml-2", attrs: { right: "" } },
                [
                  _c("template", { slot: "button-content" }, [
                    _c("em", [_vm._v("Admin")])
                  ]),
                  _vm._v(" "),
                  _c("b-dropdown-item", { attrs: { href: "" } }, [
                    _vm._v("Perfil")
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-dropdown-item",
                    {
                      on: {
                        click: function($event) {
                          return _vm.logout()
                        }
                      }
                    },
                    [_vm._v("Cerrar sesión")]
                  )
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61dd7a3d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61dd7a3d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = null
// module chunks = 